module.exports = __webpack_public_path__ + "fonts/Barlow-Medium.71ae17c9.ttf";